export const getRoleKey = (role) => {
  // Handle both number and string representations of role
  const roleMap = {
    0: 'admin',
    1: 'clab',
    2: 'recruiter',
    3: 'employer',
    '0': 'admin',
    '1': 'clab',
    '2': 'recruiter',
    '3': 'employer'
  };
  if (role in roleMap) {
    return roleMap[role];
  }
  const roleString = (role || 'clab').toLowerCase().replace(' ', '_');
  if (['master_admin', 'admin'].includes(roleString)) return 'admin';
  if (['clab_user'].includes(roleString)) return 'clab';
  return roleString;
};

// Helper function to get the correct user role for components
export const getUserRoleForComponents = (user) => {
  if (!user) return 'clab';
  // Always use getRoleKey to ensure consistent role mapping
  return getRoleKey(user.role);
};